/*
 * LC Cart Date Validator
 * Auto-corrige la "Fecha de entrega" del carrito si es del pasado o inválida.
 * Se ejecuta en TODAS las páginas para garantizar que ningún cliente complete
 * un pedido con fecha vieja, incluso si esquiva el carrito (Shop Pay, etc.).
 *
 * Reglas (deben coincidir con delivery-date-picker.liquid):
 *  - Mínima fecha = mañana
 *  - Domingos bloqueados (getDay() === 0)
 *  - Fechas en shop.metafields.custom.fechas_bloqueadas_de_entrega bloqueadas
 *
 * Si la fecha es inválida → la reemplaza por la siguiente fecha disponible.
 */
(function () {
  'use strict';

  // Lee fechas bloqueadas del data-attribute del propio <script>
  var thisScript = document.currentScript ||
    document.querySelector('script[src*="lc-cart-date-validator"]');
  var blockedRaw = (thisScript && thisScript.dataset && thisScript.dataset.blockedDates) || '';
  var blockedDates = blockedRaw.split(',')
    .map(function (d) { return d.trim(); })
    .filter(Boolean);

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function dateToStr(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function getMinDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1); // mañana
    return d;
  }

  function isBlocked(date, dateStr) {
    return date < getMinDate()
        || date.getDay() === 0
        || blockedDates.indexOf(dateStr) !== -1;
  }

  function isDateValid(dateStr) {
    if (!dateStr) return false;
    var p = dateStr.split('-');
    if (p.length !== 3) return false;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    d.setHours(0, 0, 0, 0);
    return !isBlocked(d, dateStr);
  }

  function nextAvailableDate() {
    var d = getMinDate();
    var s = dateToStr(d);
    while (isBlocked(d, s)) {
      d.setDate(d.getDate() + 1);
      s = dateToStr(d);
    }
    return s;
  }

  // No corremos en /cart, /checkout, /admin (ya tienen su propia lógica o no aplica)
  var path = window.location.pathname;
  if (path.indexOf('/checkout') === 0 || path.indexOf('/admin') === 0) return;

  // Lee carrito y corrige fecha si está vieja
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // Carrito 100% cursos/servicios (sin envío): limpiar fecha y zona, no aplican
      var _items = cart.items || [];
      var _allCourses = _items.length > 0 && _items.every(function (it) { return it.requires_shipping === false; });
      if (_allCourses) {
        if (cart.attributes && (cart.attributes['Fecha de entrega'] || cart.attributes['_zona_entrega'])) {
          return fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Fecha de entrega': '', '_zona_entrega': '' } })
          });
        }
        return;
      }
      var fecha = cart.attributes && cart.attributes['Fecha de entrega'];
      if (!fecha) return; // sin fecha, el picker la pondrá cuando abra carrito
      if (isDateValid(fecha)) return; // OK

      // Fecha inválida: auto-corregir SILENCIOSAMENTE
      var nueva = nextAvailableDate();
      if (window.console && console.log) {
        console.log('[LC validator] Fecha vieja "' + fecha + '" → corrigiendo a "' + nueva + '"');
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Fecha de entrega': nueva } })
      });
    })
    .catch(function (err) {
      if (window.console && console.error) {
        console.error('[LC validator] error:', err);
      }
    });
})();
